export const contactEvents = ['call_link', 'telegram_link', 'whatsapp_link'] as const
export const linkPlacements = ['footer', 'contact_page', 'content', 'booking_form', 'form_confirmation'] as const

export function sendAnalyticsEvent(event: string, parameters: Record<string, unknown> = {}) {
    window.gtag?.('event', event, { ...parameters, send_to: 'G-HTRGH2BWCB' })
}

export function contactLinkEvent(link: Pick<Element, 'getAttribute'>) {
    const event = link.getAttribute('data-analytics-event')
    const placement = link.getAttribute('data-analytics-placement')
    if (!contactEvents.includes(event as typeof contactEvents[number])
        || !linkPlacements.includes(placement as typeof linkPlacements[number])) return
    return { event: event!, link_placement: placement! }
}

export function initContactAnalytics() {
    document.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return
        const link = event.target.closest('a[data-analytics-event][data-analytics-placement]')
        if (!link) return
        const contact = contactLinkEvent(link)
        if (contact) sendAnalyticsEvent(contact.event, { link_placement: contact.link_placement })
    }, { capture: true })
}
